module.exports = __webpack_public_path__ + "img/new-instagram.fd46b221.svg";